var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportCardView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 443,
    height: 240,
    "aria-labelledby": titleId,
    viewBox: "0 0 443 240",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 1,
    rx: 3,
    ry: 3,
    width: 120,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    rx: 3,
    ry: 3,
    width: 107,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68,
    rx: 3,
    ry: 3,
    width: 110,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 93,
    rx: 3,
    ry: 3,
    width: 178,
    height: 11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 16,
    r: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 118,
    rx: 3,
    ry: 3,
    width: 110,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 144,
    rx: 15,
    ry: 15,
    width: 138,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 143,
    rx: 15,
    ry: 15,
    width: 66,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 144,
    rx: 15,
    ry: 15,
    width: 63,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 181,
    rx: 3,
    ry: 3,
    width: 110,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 207,
    rx: 15,
    ry: 15,
    width: 138,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 207,
    rx: 15,
    ry: 15,
    width: 66,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 207,
    rx: 15,
    ry: 15,
    width: 94,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 207,
    rx: 15,
    ry: 15,
    width: 63,
    height: 27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#96abba",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCardView);
export default __webpack_public_path__ + "static/media/report_card_view.640a49cf56ce17f8920d74adecaf30f7.svg";
export { ForwardRef as ReactComponent };